import { useTracker } from '@common/log-manager';

export const usePageViewLog = () => {
  const tracker = useTracker();

  const pageviewUBL = (catalog_product_id: string) => {
    tracker.sendImmediately({
      category: 'pageview',
      navigation: 'zpay_option',
      navigation_sub: { page_url: getUrl() },
      data: { catalog_product_id, is_opened: true },
    });
  };

  return { pageviewUBL };
};

const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};
